module.exports = __webpack_public_path__ + "img/favicon.ico.0f715650.png";